import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useB2BTranslation } from '../hooks/useB2BTranslation';
import './B2BBackButton.css';

interface B2BBackButtonProps {
  to: string;
  translationKey: string;
  className?: string;
  size?: 'small' | 'medium' | 'large';
  variant?: 'default' | 'emerald' | 'orange';
  namespace?: string;
}

const B2BBackButton: React.FC<B2BBackButtonProps> = ({
  to,
  translationKey,
  className = '',
  size = 'medium',
  variant = 'default',
  namespace = 'b2b'
}) => {
  const { t, tDashboard, tParticipantsRoot, tEvents } = useB2BTranslation();

  const buttonClasses = [
    'b2b-shared-back-button',
    `b2b-shared-back-button--${size}`,
    `b2b-shared-back-button--${variant}`,
    className
  ].filter(Boolean).join(' ');

  // Handle different translation key patterns
  const getTranslation = (key: string) => {
    if (key.startsWith('profile.')) {
      return tDashboard(key);
    }
    if (key.startsWith('dashboard.')) {
      // Remove the dashboard. prefix to avoid double prefix
      const keyWithoutPrefix = key.replace('dashboard.', '');
      return tDashboard(keyWithoutPrefix);
    }
    if (key.startsWith('brandPerception.')) {
      return tDashboard(key);
    }
    if (key.startsWith('events.')) {
      return tEvents(key);
    }
    if (key.startsWith('participants_')) {
      return tParticipantsRoot(key);
    }
    return t(key);
  };

  return (
    <Link to={to} className={buttonClasses}>
      <ArrowLeft size={16} />
      {getTranslation(translationKey)}
    </Link>
  );
};

export default B2BBackButton;
